import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Web3StatusContext } from "../contexts/Web3StatusContext";

class HardCap extends React.Component {
    static contextType = Web3StatusContext;

  state = { dataKey: null,
  finalPriceDataKey:null };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts[this.props.contract];
  
    var methodArgs = this.props.methodArgs ? this.props.methodArgs : [];
    const dataKey = contract.methods[this.props.method].cacheCall(...methodArgs);
    const finalPriceDataKey = contract.methods['finalRate'].cacheCall();
  
    // save the `dataKey` to local component state for later reference
    this.setState({ dataKey, finalPriceDataKey });
  }
  

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const contract = this.props.drizzleState.contracts[this.props.contract];

    // using the saved `dataKey`, get the variable we're interested in
    const result = contract[this.props.method][this.state.dataKey];
    const result2 = contract['finalRate'][this.state.finalPriceDataKey];
    
    if(result !== undefined && result2 !== undefined) {
      var resultNumber = this.context.web3.utils.fromWei(result.value, "ether");
      resultNumber = Number(resultNumber);

      var result2Number = Number(result2.value);

      return (resultNumber/result2Number)
    }
    
    return '--';
  }
};

export default HardCap;